module.exports = __webpack_public_path__ + "img/button-download.6317b986.png";